import { Suspense, type ComponentProps } from "react";
import { lazyNamed } from "../../routes/lazyNamed";
import type { RichEmailEditor as EagerRichEmailEditor } from "./RichEmailEditor";

// Quality pass: TipTap/ProseMirror (~0.5 MB) loads only when an editor is shown (compose drawer,
// signature card), not with the lead page or the settings screen around it.
const RichEmailEditor = lazyNamed(
  () => import("./RichEmailEditor"),
  "RichEmailEditor",
);

/** RichEmailEditor, loaded on first render; the placeholder keeps the editor's height. */
export const LazyRichEmailEditor = (
  props: ComponentProps<typeof EagerRichEmailEditor>,
) => (
  <Suspense
    fallback={
      <div
        aria-busy="true"
        className="min-h-[18rem] rounded-md border border-input"
      />
    }
  >
    <RichEmailEditor {...props} />
  </Suspense>
);
